<mat-form-field
    [ngClass]="{ 'menu-filter': source === 'menu' }"
    [floatLabel]="source === 'reports' ? 'always' : 'auto'"
>
    <mat-label *ngIf="source === 'reports'">{{label}}</mat-label>
    <mat-label *ngIf="source !== 'reports'">{{placeholderText}}</mat-label>
    <input
        [matDatepicker]="picker"
        matInput
        [min]="minDate"
        [placeholder]="placeholderText"
        readonly="true"
        [value]="effectiveDate"
        (dateChange)="onDateChanged($event)"
        [disabled]="disabled"
    />
    <mat-datepicker-toggle
        [attr.data-testid]="'effective_date_toggle'"
        [for]="picker"
        matSuffix
    ></mat-datepicker-toggle>
    <mat-datepicker
        #picker
        [dateClass]="highlightDate"
    ></mat-datepicker>
</mat-form-field>
